import { L } from '@lang';
import { Button, Placeholder } from '../../shared/ui';
import styles from './ErrorPage.module.css';

export const fallbackTexts = {
  title: 'Произошла непредвиденная ошибка',
  subtitle: 'Попробуйте перезагрузить страницу или перезайти в приложение',
  retry: 'Перезагрузить',
};

interface ErrorPageProps {
  onRetry: VoidFunction;
}

export function ErrorPage(props: ErrorPageProps) {
  const { onRetry } = props;

  return (
    <div className={styles.root}>
      <Placeholder
        title={L.t(['pwa_error_page_title', fallbackTexts.title])}
        subtitle={L.t(['pwa_error_page_subtitle', fallbackTexts.subtitle])}
        action={
          <Button onClick={onRetry} stretched>
            {L.t(['pwa_error_page_action_retry', fallbackTexts.retry])}
          </Button>
        }
      />
    </div>
  );
}
